module.exports = __webpack_public_path__ + "static/img/right.670150ad.jpg";